import React from 'react'

const HardwarePricingPage: React.FC = () => {
  return <React.Fragment>Under construction</React.Fragment>
}

export default HardwarePricingPage
